/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const sort_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.077 3v16.673m0 0L10 15.75m-3.923 3.923L2.154 15.75M17.846 20V3.327m0 0L13.923 7.25m3.923-3.923L21.77 7.25"
    />
  </svg>
)
export default sort_medium
